import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa fa-tachometer',
    },
  {
    title: true,
    name: 'List'
  },
  {
    name: 'Company List',
    url: '/companies',
    icon: 'fa fa-list'
  },
];
